(function () {
  "use strict";
  var SECCAO = "sar-gaveta", gaveta, veu, relogio = null;
  var CHAVE_CRON = "sarCronDesde";

  function montar() {
    veu = document.querySelector(".sar-veu");
    gaveta = document.querySelector(".sar-gaveta");
    return !!(gaveta && veu);
  }

  /* ---------- moeda ----------
     Limiares em centimos da moeda BASE (GBP). Shopify.currency.rate e o
     multiplicador base -> moeda apresentada. cart.total_price ja vem na
     moeda apresentada, por isso convertemos os limiares para o mesmo espaco. */
  function taxa() {
    try {
      var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
      return (isFinite(r) && r > 0) ? r : 1;
    } catch (e) { return 1; }
  }
  /* ,90 seguinte (em centimos) >= c: 10772 -> 10790 */
  function cima90(c) { return c > 0 ? Math.ceil((c - 90) / 100) * 100 + 90 : 0; }
  /* "USD=10990/14990;CAD=15990/21990" -> [10990,14990] para a moeda ativa */
  function limiaresLocais(txt) {
    var m = moedaAtiva(), res = [0, 0];
    (txt || "").split(";").forEach(function (par) {
      var p = par.split("=");
      if (p.length === 2 && p[0].trim().toUpperCase() === m) {
        var v = p[1].split("/");
        res = [parseInt(v[0], 10) || 0, parseInt(v[1], 10) || 0];
      }
    });
    return res;
  }
  function moedaAtiva() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP"; }
    catch (e) { return "GBP"; }
  }
  function dinheiro(centimos) {
    var v = centimos / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency", currency: moedaAtiva(),
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return v.toFixed(2); }
  }

  /* ---------- cronometro ---------- */
  function cronometro() {
    if (relogio) { clearInterval(relogio); relogio = null; }
    var caixa = gaveta.querySelector("[data-sar-cron]");
    var alvo = gaveta.querySelector("[data-sar-cron-n]");
    if (!caixa || !alvo) return;

    var minutos = parseInt(gaveta.getAttribute("data-minutos"), 10);
    if (!minutos || minutos < 1) minutos = 10;
    var total = minutos * 60;

    var desde;
    try { desde = parseInt(sessionStorage.getItem(CHAVE_CRON), 10); } catch (e) { desde = null; }
    if (!desde || isNaN(desde)) {
      desde = Date.now();
      try { sessionStorage.setItem(CHAVE_CRON, String(desde)); } catch (e) {}
    }
    function tique() {
      var resta = total - Math.floor((Date.now() - desde) / 1000);
      if (resta <= 0) {
        desde = Date.now();
        try { sessionStorage.setItem(CHAVE_CRON, String(desde)); } catch (e) {}
        resta = total;
      }
      var mm = Math.floor(resta / 60), ss = resta % 60;
      alvo.textContent = (mm < 10 ? "0" : "") + mm + ":" + (ss < 10 ? "0" : "") + ss;
    }
    tique();
    relogio = setInterval(tique, 1000);
  }

  /* ---------- barra frio -> quente + faixa de ganho ---------- */
  function pintar() {
    var barra = gaveta.querySelector("[data-sar-barra]");
    var t = taxa();
    /* r1/r2: limiar REAL na moeda do cliente (GBP x taxa), o que a Shopify usa no desconto.
       l1/l2: valor MOSTRADO, redondo na moeda local (definicao "limiares_moedas"), nunca abaixo do real. */
    var r1 = Math.round(parseInt(gaveta.getAttribute("data-l1"), 10) * t);
    var r2 = Math.round(parseInt(gaveta.getAttribute("data-l2"), 10) * t);
    var mostrar = moedaAtiva() === "GBP" ? [0, 0] : limiaresLocais(gaveta.getAttribute("data-lm"));
    var l1 = moedaAtiva() === "GBP" ? r1 : Math.max(mostrar[0] || 0, cima90(r1));
    var l2 = moedaAtiva() === "GBP" ? r2 : Math.max(mostrar[1] || 0, cima90(r2));
    var p1 = parseInt(gaveta.getAttribute("data-p1"), 10);
    var p2 = parseInt(gaveta.getAttribute("data-p2"), 10);
    var base = parseInt(gaveta.getAttribute("data-base"), 10) || 0;
    if (!l1 || !l2 || l2 <= l1) return;

    if (barra) {
      var pct = Math.max(0, Math.min(100, (base / l2) * 100));
      var posM1 = (l1 / l2) * 100;

      var fio = barra.querySelector("[data-sar-fio]");
      if (fio) {
        fio.style.width = pct + "%";
      }
      var m1 = barra.querySelector("[data-sar-marca1]");
      if (m1) { m1.style.left = posM1 + "%"; m1.classList.toggle("atingida", base >= r1); }
      var m2 = barra.querySelector("[data-sar-marca2]");
      if (m2) m2.classList.toggle("atingida", base >= r2);
      var d1 = barra.querySelector("[data-sar-deg1]");
      if (d1) { d1.style.left = posM1 + "%"; d1.classList.toggle("atingido", base >= r1); }
      var d2 = barra.querySelector("[data-sar-deg2]");
      if (d2) d2.classList.toggle("atingido", base >= r2);
      var v1 = barra.querySelector("[data-sar-v1]"); if (v1) v1.textContent = dinheiro(l1);
      var v2 = barra.querySelector("[data-sar-v2]"); if (v2) v2.textContent = dinheiro(l2);

      var frase = barra.querySelector("[data-sar-frase]");
      var ganho = false, txt = "";
      if (base >= r2) {
        ganho = true;
        txt = (barra.getAttribute("data-t-max") || "Maximum discount unlocked: [p]% off").replace("[p]", p2);
      } else if (base >= r1) {
        ganho = true;
        txt = (barra.getAttribute("data-t-unl") || "[p1]% off unlocked. Add [v] more and get [p2]% off").replace("[p1]", p1).replace("[v]", dinheiro(l2 - base)).replace("[p2]", p2);
      } else {
        txt = (barra.getAttribute("data-t-add") || "Add [v] more and get [p]% off").replace("[v]", dinheiro(l1 - base)).replace("[p]", p1);
      }
      if (frase) frase.innerHTML = txt;
      barra.classList.toggle("sar-barra--ganho", ganho);
    }

    /* Portes: tarifa mais barata real (Standard Home Delivery, 2,60 GBP em
       todos os mercados, verificado a 22/10). Convertida para a moeda do
       cliente com a mesma taxa da Shopify. Nao ha portes gratis. */
    var env = gaveta.querySelector("[data-sar-envio]");
    if (env) {
      var cEnv = parseInt(env.getAttribute("data-sar-envio"), 10) || 0;
      var cEnv2 = parseInt(env.getAttribute("data-sar-envio2"), 10) || 0;
      /* As duas tarifas reais da loja (Standard e Priority), na moeda do cliente. */
      if (cEnv > 0 && cEnv2 > 0) {
        env.textContent = "Standard " + dinheiro(Math.round(cEnv * t)) + " or Priority " +
          dinheiro(Math.round(cEnv2 * t)) + ", chosen at checkout";
      } else if (cEnv > 0) {
        env.textContent = "from " + dinheiro(Math.round(cEnv * t)) + ", calculated at checkout";
      } else {
        env.textContent = "calculated at checkout";
      }
    }

    /* A faixa de desconto e o total sao renderizados em Liquid
       com os valores REAIS da Shopify (cart.cart_level_discount_applications
       e cart.total_price). O JS nao os recalcula, para nunca mostrar
       um total diferente do que o cliente paga no checkout. */
  }

  /* ---------- rede ---------- */
  function pedir(url) {
    return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.ok ? r.text() : ""; });
  }
  function desembrulhar(html) {
    var caixa = document.createElement("div");
    caixa.innerHTML = html;
    var dentro = caixa.querySelector('[id^="shopify-section-"]');
    return dentro ? dentro.innerHTML : caixa.innerHTML;
  }
  /* Pedidos do proprio carrinho levam este cabecalho: o intercetor de
     fetch la em baixo ignora-os. Antes cada clique fazia o pedido, mais um
     redesenho pelo intercetor e outro pelo .then() = 3 pedidos em serie. */
  var INTERNO = "X-Sar-Interno";
  /* POST a /cart/add.js ou /cart/change.js ja com a gaveta renderizada na
     mesma resposta (Section Rendering da Shopify): um so pedido. */
  function postCarrinho(url, corpo) {
    corpo.sections = SECCAO;
    corpo.sections_url = window.location.pathname;
    var h = { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" };
    h[INTERNO] = "1";
    return fetch(url, { method: "POST", headers: h, body: JSON.stringify(corpo) })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error((j && (j.description || j.message)) || "cart");
          return j;
        });
      });
  }
  /* Fila: os cliques seguidos (seguro, quantidades) vao por ordem e so a
     resposta do ultimo redesenha a gaveta, para nao haver saltos. */
  var fila = Promise.resolve(), naFila = 0;
  function emFila(fn) {
    naFila++;
    var p = fila.then(fn);
    fila = p.catch(function () {}).then(function () { naFila--; });
    return p;
  }
  function aplicarResposta(j) {
    if (naFila > 1) return;
    if (j && j.sections && j.sections[SECCAO]) aplicarSeccao(j.sections[SECCAO]);
    else return redesenhar();
  }
  function redesenhar() {
    return pedir("?sections=" + SECCAO).then(function (txt) {
      if (!txt) return;
      var j; try { j = JSON.parse(txt); } catch (e) { return; }
      if (!j[SECCAO]) return;
      aplicarSeccao(j[SECCAO]);
    });
  }
  /* 23/10: render PARCIAL. Antes cada resposta substituia a gaveta inteira
     (cerca de 80 a 110 ms no PC, 4x mais num telemovel) e bloqueava os toques
     seguintes. Agora so se trocam as zonas cujo HTML do servidor mudou
     desde a ultima resposta: cabecalho, corpo (barra e artigos), sugestoes
     e rodape. */
  var ultimo = {};
  var ZONAS = { cab: ".sar-gaveta__cabecalho", corpo: ".sar-gaveta__corpo", sug: ".sar-sug", rod: ".sar-gaveta__rodape" };
  function aplicarParcial(nGaveta) {
    var k, a, n, mudouCorpo = false;
    for (k in ZONAS) {
      a = gaveta.querySelector(ZONAS[k]); n = nGaveta.querySelector(ZONAS[k]);
      if (!!a !== !!n) return null;
    }
    if (!gaveta.querySelector(".sar-meio") || !nGaveta.querySelector(".sar-meio")) return null;
    for (k in ZONAS) {
      n = nGaveta.querySelector(ZONAS[k]);
      if (!n) continue;
      var h = n.outerHTML;
      if (ultimo[k] === h) continue;
      ultimo[k] = h;
      var velho = gaveta.querySelector(ZONAS[k]), st = velho.scrollTop;
      velho.replaceWith(n);
      if (st) n.scrollTop = st;
      if (k === "corpo") mudouCorpo = true;
    }
    return { corpo: mudouCorpo };
  }
  function aplicarSeccao(html) {
    {
      var novo = document.createElement("div");
      novo.innerHTML = desembrulhar(html);
      var nGaveta = novo.querySelector(".sar-gaveta");
      if (!nGaveta) return;
      var parcial = Object.keys(ultimo).length ? aplicarParcial(nGaveta) : null;
      if (parcial) {
        ["data-l1","data-l2","data-lm","data-p1","data-p2","data-base","data-total","data-minutos"].forEach(function (a) {
          var v = nGaveta.getAttribute(a);
          if (v !== null) gaveta.setAttribute(a, v);
        });
        contaNoCabecalho();
        pintar();
        espacarSug();
        cronometro();
        if (parcial.corpo && pickerAberto) {
          var pg = pickerAberto, sg = escolhido ? escolhido.sel.slice() : null;
          escolhido = null;
          abrirPicker(pg, null, sg);
        }
        return;
      }
      for (var kz in ZONAS) { var z = nGaveta.querySelector(ZONAS[kz]); ultimo[kz] = z ? z.outerHTML : ""; }
      var estavaAberta = gaveta.classList.contains("aberta");
      /* O seletor de variantes vive dentro da gaveta, por isso desaparece
         aqui. Guardar o produto e as opcoes ja escolhidas para o repor. */
      var pickerGuardado = pickerAberto;
      var selGuardada = escolhido ? escolhido.sel.slice() : null;
      /* Guardar o scroll: substituir o HTML punha a lista no topo. */
      var rolos = [".sar-meio", ".sar-gaveta__corpo", ".sar-sug"].map(function (sel) {
        var c = gaveta.querySelector(sel);
        return c ? [c.scrollTop, c.scrollLeft] : null;
      });
      gaveta.innerHTML = nGaveta.innerHTML;
      [".sar-meio", ".sar-gaveta__corpo", ".sar-sug"].forEach(function (sel, i) {
        var c = gaveta.querySelector(sel);
        if (c && rolos[i]) { c.scrollTop = rolos[i][0]; c.scrollLeft = rolos[i][1]; }
      });
      ["data-l1","data-l2","data-lm","data-p1","data-p2","data-base","data-total","data-minutos"].forEach(function (a) {
        var v = nGaveta.getAttribute(a);
        if (v !== null) gaveta.setAttribute(a, v);
      });
      if (estavaAberta) gaveta.classList.add("aberta");
      escolhido = null;
      contaNoCabecalho();
      pintar();
      espacarSug();
      cronometro();
      if (pickerGuardado) abrirPicker(pickerGuardado, null, selGuardada);
    }
  }
  function contaNoCabecalho() {
    var n = gaveta.querySelector(".sar-gaveta__conta");
    if (!n) return;
    var q = n.textContent.trim();
    document.querySelectorAll(".cart-count-bubble span:first-child, [data-cart-count], .cart-count").forEach(function (e) {
      e.textContent = q;
    });
  }

  /* 24/10e (dono): sugestoes com o mesmo espaco entre todos os cartoes (sem espalhar ate ao fundo)
     e todos os blocos da gaveta com a mesma largura: quando a lista de produtos tem barra de
     deslocamento, a margem direita do corpo desconta a largura da barra. */
  function espacarSug() {
    if (!gaveta) return;
    var l = gaveta.querySelector(".sar-sug__lista");
    if (l) l.style.rowGap = "";
    var m = gaveta.querySelector(".sar-meio"), c = gaveta.querySelector(".sar-gaveta__corpo");
    if (!m || !c) return;
    c.style.paddingRight = "";
    var sw = m.offsetWidth - m.clientWidth;
    if (sw > 0) c.style.paddingRight = Math.max(0, parseFloat(getComputedStyle(c).paddingRight) - sw) + "px";
  }
  window.addEventListener("resize", function () { espacarSug(); });

  /* ---------- abrir / fechar ---------- */
  function abrir() {
    if (!gaveta && !montar()) return;
    veu.classList.add("aberta");
    gaveta.classList.add("aberta");
    espacarSug();
    document.documentElement.style.overflow = "hidden";
    var f = gaveta.querySelector(".sar-gaveta__fechar");
    if (f) f.focus({ preventScroll: true });
  }
  function fechar() {
    if (!gaveta) return;
    veu.classList.remove("aberta");
    gaveta.classList.remove("aberta");
    document.documentElement.style.overflow = "";
    fecharPicker();
  }

  /* ---------- accoes ---------- */
  /* Soma "delta" centimos a um valor mostrado (subtotal, total). So serve
     para o ecra reagir no mesmo instante; a resposta da Shopify traz logo a
     seguir os valores reais e substitui estes. */
  function somarValor(sel, delta) {
    /* Pode haver mais do que um (o total aparece tambem no botao de checkout). */
    gaveta.querySelectorAll(sel).forEach(function (el) {
      var c = parseInt(el.getAttribute("data-centimos"), 10);
      if (isNaN(c)) return;
      c = Math.max(0, c + delta);
      el.setAttribute("data-centimos", c);
      el.textContent = dinheiro(c);
    });
  }
  function somarConta(delta) {
    var n = gaveta.querySelector(".sar-gaveta__conta");
    if (!n) return;
    n.textContent = Math.max(0, (parseInt(n.textContent, 10) || 0) + delta);
    contaNoCabecalho();
  }

  function mudar(chave, quantidade, linha) {
    /* Otimista: numero, preco da linha, subtotal e total mudam ja.
       A resposta da Shopify corrige depois os descontos (Kaching, escaloes). */
    if (linha) {
      var nEl = linha.querySelector(".sar-passo__n");
      var antes = parseInt(nEl.textContent, 10) || 0;
      var dq = quantidade - antes;
      var unit = parseInt(linha.getAttribute("data-unit"), 10) || 0;
      var orig = parseInt(linha.getAttribute("data-orig"), 10) || unit;
      if (quantidade === 0) linha.classList.add("a-sair");
      else {
        nEl.textContent = quantidade;
        var val = linha.querySelector(".sar-linha__valor");
        if (val && unit) { val.setAttribute("data-centimos", unit * quantidade); val.textContent = dinheiro(unit * quantidade); }
      }
      somarValor("[data-sar-subtotal]", orig * dq);
      somarValor("[data-sar-total]", unit * dq);
      somarConta(dq);
    }
    /* A chave da linha muda a cada alteracao (os descontos Kaching mudam o
       hash), por isso dois toques seguidos com a chave antiga davam erro.
       Se a variante so aparece numa linha, usa-se o id da variante, que
       nunca muda; senao a chave, decidida so na hora de enviar. */
    var variante = String(chave).split(":")[0];
    return emFila(function () {
      var mesmas = gaveta.querySelectorAll('.sar-linha[data-chave^="' + variante + ':"]').length;
      var id = mesmas === 1 ? variante : (linha ? linha.getAttribute("data-chave") : chave);
      return postCarrinho("/cart/change.js", { id: id, quantity: quantidade });
    }).then(aplicarResposta).catch(function () { return redesenhar(); });
  }
  /* Linha provisoria: aparece no proprio toque (foto, nome, preco, 1 un.),
     a resposta da Shopify substitui-a pela linha real. */
  function linhaPrevia(previa) {
    var lista = gaveta.querySelector(".sar-gaveta__lista");
    if (!lista || !previa) return;
    var li = document.createElement("li");
    li.className = "sar-linha a-entrar";
    li.innerHTML = (previa.img ? '<img class="sar-linha__foto" alt="" src="' + previa.img + '">' : "") +
      '<div class="sar-linha__meio"><span class="sar-linha__titulo"></span><div class="sar-linha__variante"></div>' +
      '<div class="sar-linha__baixo"><div class="sar-linha__qtd"><div class="sar-passo"><span class="sar-passo__b">&minus;</span>' +
      '<span class="sar-passo__n">1</span><span class="sar-passo__b">+</span></div></div>' +
      '<div class="sar-linha__preco"><span class="sar-linha__valor"></span></div></div></div>';
    li.querySelector(".sar-linha__titulo").textContent = previa.nome || "";
    li.querySelector(".sar-linha__variante").textContent = previa.variante || "";
    li.querySelector(".sar-linha__valor").textContent = previa.preco ? dinheiro(previa.preco) : "";
    lista.insertBefore(li, lista.firstChild); /* a Shopify poe os artigos novos no topo */
    if (previa.preco) { somarValor("[data-sar-subtotal]", previa.preco); somarValor("[data-sar-total]", previa.preco); }
    somarConta(1);
  }
  function previaDoCartao(cartao, preco, variante) {
    if (!cartao) return null;
    var img = cartao.querySelector("img");
    var nome = cartao.querySelector(".sar-sug__nome");
    return { img: img ? img.currentSrc || img.src : "", nome: nome ? nome.textContent.trim() : "",
      preco: preco || parseInt(cartao.getAttribute("data-preco"), 10) || 0, variante: variante || "" };
  }
  function juntar(idVariante, botao, previa, jaMostrada) {
    if (botao) botao.disabled = true;
    if (previa) linhaPrevia(previa); else if (!jaMostrada) gaveta.classList.add("a-trabalhar");
    return emFila(function () {
      return postCarrinho("/cart/add.js", { items: [{ id: Number(idVariante), quantity: 1 }] });
    }).then(aplicarResposta).catch(function () { return redesenhar(); })
      .finally(function () { gaveta.classList.remove("a-trabalhar"); if (botao) botao.disabled = false; });
  }
  /* Seguro: como na Lugino, o visto, o preco e o total mudam no mesmo
     instante do toque; o pedido segue por tras numa so ida ao servidor. */
  function seguro(caixa) {
    var idVariante = caixa.getAttribute("data-sar-seguro");
    var preco = parseInt(caixa.getAttribute("data-sar-seguro-preco"), 10) || 0;
    var ligar = caixa.checked;
    var rot = caixa.closest(".sar-seguro");
    if (rot) rot.classList.toggle("ligado", ligar);
    somarValor("[data-sar-subtotal]", ligar ? preco : -preco);
    somarValor("[data-sar-total]", ligar ? preco : -preco);
    somarConta(ligar ? 1 : -1);
    return emFila(function () {
      /* Remover pelo id da variante: funciona mesmo que a gaveta ainda
         nao tenha a chave da linha (ligar e desligar seguidos). */
      return ligar
        ? postCarrinho("/cart/add.js", { items: [{ id: Number(idVariante), quantity: 1 }] })
        : postCarrinho("/cart/change.js", { id: String(idVariante), quantity: 0 });
    }).then(aplicarResposta).catch(function () {
      /* Falhou: repor o estado real. */
      return redesenhar();
    });
  }

  /* ---------- seletor de variantes para as sugestoes ----------
     Produtos com 60-320 variantes (Cor x Marca do carro). Adicionar
     a primeira variante enviaria o emblema errado, por isso abre-se
     um painel e carrega-se /products/<handle>.js a pedido.          */
  var prodCache = {}, escolhido = null;
  /* Handle do produto cujo seletor esta aberto, guardado a parte de
     "escolhido" porque redesenhar() substitui a gaveta inteira. As apps da
     loja fazem POST /cart/update.js ao carregar a pagina (duas vezes, aos
     ~480ms); cada uma disparava um redesenhar() que apagava o seletor que o
     link do email tinha acabado de abrir - dai a gaveta aparecer vazia. */
  var pickerAberto = null;

  /* Algumas opcoes ja se chamam "Choose your set"; nao lhes voltar a por
     "Choose" a frente. */
  function pedido(nome) {
    return /^choose/i.test(nome) ? nome : ("Choose " + nome.toLowerCase());
  }

  function abrirPicker(handle, botao, selAnterior) {
    var painel = gaveta.querySelector("[data-sar-picker]");
    if (!painel) return;
    pickerAberto = handle;
    if (botao) botao.disabled = true;
    var p = prodCache[handle]
      ? Promise.resolve(prodCache[handle])
      : fetch("/products/" + handle + ".js").then(function (r) { return r.json(); })
          .then(function (j) { prodCache[handle] = j; return j; });
    return p.then(function (prod) {
      /* Re-procurar o painel: entre o pedido e a resposta pode ter havido um
         redesenhar() (uma app da loja escreve atributos do carrinho ao
         carregar a pagina) e o painel capturado acima ficaria orfao. */
      painel = gaveta.querySelector("[data-sar-picker]");
      if (!painel) return;
      escolhido = { prod: prod, opcoes: prod.options.map(function (o) {
        return (typeof o === "string") ? o : o.name; }), sel: [] };
      painel.querySelector("[data-sar-picker-nome]").textContent = prod.title;
      var foto = painel.querySelector("[data-sar-picker-foto]");
      var imgUrl = prod.featured_image || (prod.images && prod.images[0]);
      if (foto) {
        if (imgUrl) { foto.src = imgUrl + (imgUrl.indexOf("?") === -1 ? "?" : "&") + "width=200"; foto.alt = prod.title; }
        else foto.removeAttribute("src");
      }
      precoPicker(painel, prod.price, prod.compare_at_price);
      var caixa = painel.querySelector("[data-sar-picker-opcoes]");
      caixa.innerHTML = escolhido.opcoes.map(function (nome, i) {
        var vals = [];
        prod.variants.forEach(function (v) {
          var val = v.options[i];
          if (val && vals.indexOf(val) === -1) vals.push(val);
        });
        return "<label class=\"sar-picker__campo\"><span>" + nome + "</span>" +
          "<select data-sar-opt=\"" + i + "\">" +
          "<option value=\"\" disabled selected>" + pedido(nome) + "</option>" +
          vals.map(function (v) { return "<option>" + v + "</option>"; }).join("") +
          "</select></label>";
      }).join("");
      /* Nada fica pre-escolhido: a marca do carro tem de ser uma escolha
         explicita, senao o cliente carrega em Add e leva a primeira da lista. */
      escolhido.sel = escolhido.opcoes.map(function () { return null; });
      /* Se o painel foi reconstruido por um redesenhar(), devolver as opcoes
         que o cliente ja tinha escolhido em vez de o obrigar a comecar outra vez. */
      if (selAnterior) {
        caixa.querySelectorAll("[data-sar-opt]").forEach(function (s, i) {
          if (!selAnterior[i]) return;
          s.value = selAnterior[i];
          if (s.value === selAnterior[i]) escolhido.sel[i] = selAnterior[i];
        });
      }
      painel.hidden = false;
      assentarPicker(painel);
      atualizarPicker();
      if (botao) botao.disabled = false;
    }).catch(function () { if (botao) botao.disabled = false; });
  }

  function varianteEscolhida() {
    if (!escolhido) return null;
    for (var i = 0; i < escolhido.prod.variants.length; i++) {
      var v = escolhido.prod.variants[i], bate = true;
      for (var j = 0; j < escolhido.sel.length; j++) {
        if (v.options[j] !== escolhido.sel[j]) { bate = false; break; }
      }
      if (bate) return v;
    }
    return null;
  }

  function atualizarPicker() {
    var painel = gaveta.querySelector("[data-sar-picker]");
    var bt = painel.querySelector("[data-sar-picker-add]");
    var v = varianteEscolhida();
    if (v && v.available) {
      bt.disabled = false;
      bt.textContent = "Add " + dinheiro(v.price);
      bt.setAttribute("data-id", v.id);
      precoPicker(painel, v.price, v.compare_at_price);
    } else {
      bt.disabled = true;
      bt.removeAttribute("data-id");
      /* Dizer qual a opcao que falta, em vez de um "Unavailable" mudo. */
      var falta = null;
      for (var k = 0; k < escolhido.sel.length; k++) {
        if (!escolhido.sel[k]) { falta = escolhido.opcoes[k]; break; }
      }
      bt.textContent = falta ? (pedido(falta) + " first") : (v ? "Sold out" : "Unavailable");
      precoPicker(painel, escolhido.prod.price, escolhido.prod.compare_at_price);
    }
  }

  /* Preco da linha pendente. Comeca no preco base do produto e passa ao da
     variante assim que ela esta escolhida. */
  function precoPicker(painel, centimos, comparar) {
    var alvo = painel.querySelector("[data-sar-picker-preco]");
    if (!alvo) return;
    var html = dinheiro(centimos);
    if (comparar && comparar > centimos) html += "<s>" + dinheiro(comparar) + "</s>";
    alvo.innerHTML = html;
  }

  /* A linha pendente entra no topo do carrinho. Se a gaveta ja tiver produtos
     e estiver rolada para baixo, subir para o cliente a ver — antes o painel
     flutuava e no telemovel tapava o carrossel de sugestoes. */
  function assentarPicker(painel) {
    painel.style.bottom = "";
    gaveta.classList.add("com-pendente");
    try {
      [".sar-gaveta__corpo", ".sar-meio"].forEach(function (sel) {
        var c = gaveta.querySelector(sel);
        if (c && c.scrollHeight > c.clientHeight) c.scrollTop = 0;
      });
    } catch (e) {}
  }

  function fecharPicker() {
    var painel = gaveta.querySelector("[data-sar-picker]");
    if (painel) { painel.hidden = true; painel.style.bottom = ""; }
    gaveta.classList.remove("com-pendente");
    escolhido = null;
    pickerAberto = null;
  }

  /* ---------- ligacao ---------- */
  function ligar() {
    if (!montar()) return;

    /* fase de CAPTURA: corre antes dos handlers do tema (cart-drawer.js
       continua carregado e disputava o clique no icone do carrinho) */
    document.addEventListener("click", function (e) {
      if (e.target.closest(".sar-gaveta__fechar") || e.target.classList.contains("sar-veu")) {
        e.preventDefault(); fechar(); return;
      }
      var saco = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, .header__icon--cart');
      if (saco && !e.target.closest(".sar-gaveta")) {
        e.preventDefault();
        gaveta.classList.add("a-trabalhar");
        abrir();
        redesenhar().finally(function () { gaveta.classList.remove("a-trabalhar"); });
        return;
      }
      var b = e.target.closest("[data-sar-qtd]");
      if (b) {
        e.preventDefault();
        var linha = b.closest(".sar-linha"); if (!linha) return;
        var chave = linha.getAttribute("data-chave");
        var n = parseInt(linha.querySelector(".sar-passo__n").textContent.trim(), 10) || 1;
        var acao = b.getAttribute("data-sar-qtd");
        if (acao === "tirar") return mudar(chave, 0, linha);
        if (acao === "menos") return mudar(chave, Math.max(0, n - 1), linha);
        if (acao === "mais") return mudar(chave, n + 1, linha);
      }
      /* Cartao de sugestao com seletores (como na Lugino): junta a variante
         escolhida. Se faltar uma opcao, marca-a e nao junta nada. */
      var up = e.target.closest("button[data-sar-up-add]");
      if (up) {
        e.preventDefault();
        var cartao = up.closest("[data-sar-up]");
        var hUp = cartao.getAttribute("data-sar-up");
        var sels = Array.prototype.slice.call(cartao.querySelectorAll("[data-sar-up-opt]"));
        var falta = sels.filter(function (s) { return !s.value; });
        sels.forEach(function (s) { s.classList.toggle("por-escolher", !s.value); });
        if (falta.length) { try { falta[0].focus(); } catch (er) {} return; }
        var valores = sels.map(function (s) { return s.value; });
        up.disabled = true;
        /* Linha provisoria ja no toque, antes de ir buscar a variante. */
        linhaPrevia(previaDoCartao(cartao, 0, valores.join(" / ")));
        (prodCache[hUp] ? Promise.resolve(prodCache[hUp])
          : fetch("/products/" + hUp + ".js").then(function (r) { return r.json(); })
              .then(function (pj) { prodCache[hUp] = pj; return pj; }))
          .then(function (pj) {
            var v = null;
            pj.variants.forEach(function (x) {
              if (!v && valores.every(function (val, i) { return x.options[i] === val; })) v = x;
            });
            if (v && v.available) return juntar(v.id, up, null, true);
            up.disabled = false;
            redesenhar();
            /* Variante fora das 250 do .js ou esgotada: abre o seletor completo. */
            return abrirPicker(hUp, null, valores);
          }).catch(function () { up.disabled = false; redesenhar(); });
        return;
      }
      var j = e.target.closest("button[data-sar-juntar]");
      if (j) { e.preventDefault(); juntar(j.getAttribute("data-sar-juntar"), j, previaDoCartao(j.closest("[data-sar-up]"))); return; }
      var esc = e.target.closest("button[data-sar-escolher]");
      if (esc) { e.preventDefault(); abrirPicker(esc.getAttribute("data-sar-escolher"), esc); return; }
      if (e.target.closest("[data-sar-picker-fechar]")) { e.preventDefault(); fecharPicker(); return; }
      var addv = e.target.closest("[data-sar-picker-add]");
      if (addv && addv.getAttribute("data-id")) {
        e.preventDefault();
        var id = addv.getAttribute("data-id");
        fecharPicker();
        juntar(id, addv);
      }
    }, true);

    document.addEventListener("change", function (e) {
      var c = e.target.closest("[data-sar-seguro]");
      if (c) { seguro(c); return; }
      var upo = e.target.closest("[data-sar-up-opt]");
      if (upo) { upo.classList.toggle("por-escolher", !upo.value); return; }
      var opt = e.target.closest("[data-sar-opt]");
      if (opt && escolhido) {
        escolhido.sel[parseInt(opt.getAttribute("data-sar-opt"), 10)] = opt.value;
        atualizarPicker();
      }
    });

    /* Opcoes dos seletores das sugestoes: so entram quando o cliente toca. */
    function encher(sel) {
      if (!sel || sel.__cheio) return;
      sel.__cheio = true;
      var vals; try { vals = JSON.parse(sel.getAttribute("data-vals") || "[]"); } catch (er) { vals = []; }
      var atual = sel.value, frag = document.createDocumentFragment();
      Array.prototype.slice.call(sel.options).forEach(function (o) { if (o.value) o.remove(); });
      vals.forEach(function (v) {
        var o = document.createElement("option"); o.value = v; o.textContent = v;
        if (v === atual) o.selected = true;
        frag.appendChild(o);
      });
      sel.appendChild(frag);
    }
    ["touchstart", "mousedown", "focusin", "keydown"].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var s = e.target && e.target.closest && e.target.closest(".sar-sug__s");
        if (s) encher(s);
      }, { capture: true, passive: true });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && gaveta.classList.contains("aberta")) fechar();
    });

    /* Dawn / FullStack: qualquer POST a /cart/* reabre e redesenha */
    var fetchOriginal = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var opc = arguments[1];
      var interno = !!(opc && opc.headers && opc.headers[INTERNO]);
      var r = fetchOriginal.apply(this, arguments);
      if (!interno && typeof url === "string" && /\/cart\/(add|change|update)/.test(url) && url.indexOf("sections=") === -1) {
        /* SO as adicoes abrem a gaveta. Apps da loja (pixel do Facebook,
           entre outras) escrevem atributos com /cart/update.js ao carregar
           a pagina; abrir a gaveta nesses casos fazia-a aparecer sozinha
           a direita mesmo com o carrinho vazio. */
        var ehAdicao = /\/cart\/add/.test(url);
        r.then(function () {
          if (ehAdicao) { gaveta.classList.add("a-trabalhar"); abrir(); }
          redesenhar().finally(function () { gaveta.classList.remove("a-trabalhar"); });
        }).catch(function () {});
      }
      return r;
    };

    pintar();
    cronometro();

    /* Intercetar o formulario de produto.
       O product-form.js do tema faz:
         this.cart = querySelector("cart-notification") || querySelector("cart-drawer")
       Como removemos ambos, this.cart fica null, o tema deixa de intercetar,
       e o formulario submete-se nativamente -> o browser navega para /cart.
       Apanhamos o submit na fase de captura e tratamos nos aqui. */
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || form.tagName !== "FORM") return;
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/cart/add") === -1) return;
      e.preventDefault();
      e.stopPropagation();
      var bt = form.querySelector('[type="submit"]');
      if (bt) bt.classList.add("loading");
      var fd = new FormData(form);
      fd.append("sections", SECCAO);
      fd.append("sections_url", window.location.pathname);
      var hs = { "X-Requested-With": "XMLHttpRequest" };
      hs[INTERNO] = "1";
      fetch("/cart/add.js", {
        method: "POST",
        body: fd,
        headers: hs
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          abrir();
          if (j && j.sections && j.sections[SECCAO]) aplicarSeccao(j.sections[SECCAO]);
          else return redesenhar();
        })
        .catch(function (err) { console.error("sar-gaveta:", err); })
        .finally(function () { if (bt) bt.classList.remove("loading"); });
    }, true);

    /* Os formularios do Shopify (mudar de pais/moeda) guardam o URL de
       chegada em return_to. Se o cliente veio de um email com ?escolher= ou
       ?carrinho=1, mudar de pais voltava a esse URL e reabria a gaveta com o
       produto do email. Limpamos esses parametros em todos os return_to. */
    try {
      Array.prototype.forEach.call(document.querySelectorAll('input[name="return_to"]'), function (inp) {
        var v = inp.value || "";
        var nv = v.replace(/([?&])(escolher=[a-z0-9-]+|carrinho=1)(&|$)/ig, "$1").replace(/([?&])(escolher=[a-z0-9-]+|carrinho=1)(&|$)/ig, "$1").replace(/[?&]+$/, "").replace("?&", "?");
        if (nv !== v) inp.value = nv || "/";
      });
    } catch (e) {}

    /* Vem de um email com ?escolher=<handle>: abre a gaveta e o seletor de
       variantes desse produto, para o cliente escolher a marca do carro sem
       ter de ir a pagina do produto. */
    var mEsc = window.location.search.match(/[?&]escolher=([a-z0-9-]+)/i);
    if (mEsc) {
      abrir();
      abrirPicker(mEsc[1], null);
      redesenhar();
      try {
        var limpoE = window.location.pathname +
          window.location.search.replace(/([?&])escolher=[a-z0-9-]+(&|$)/i, "$1").replace(/[?&]$/, "");
        window.history.replaceState({}, "", limpoE);
      } catch (e) {}
    }

    /* Chegou da pagina /cart (redirecionada pela seccao): abre a gaveta e
       limpa o parametro do URL para nao ficar no historico. */
    if (/[?&]carrinho=1(&|$)/.test(window.location.search)) {
      abrir();
      redesenhar();
      try {
        var limpo = window.location.pathname +
          window.location.search.replace(/([?&])carrinho=1(&|$)/, "$1").replace(/[?&]$/, "");
        window.history.replaceState({}, "", limpo);
      } catch (e) {}
    }

    /* Rede de seguranca: se o cliente aterrar na pagina /cart (por um link
       que escapou, ou por navegacao direta), abre a gaveta por cima em vez
       de o deixar com o carrinho antigo do tema. */
    if (/^\/cart\/?$/.test(window.location.pathname)) {
      abrir();
      redesenhar();
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ligar);
  else ligar();
})();

